import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';

type Props = {
  description?: string
}

const BaseInfo: React.FC<Props> = ({ description }) => {
  // const testStr = 'aaa<br />cccc';
  const { t } = useTranslation();
  return (
    <div className={styles.main_infos}>
      <div className={styles.item_ele}>
        <div className={styles.lable_name}>{t('description_wrod')}</div>
        {
          // eslint-disable-next-line max-len
        description && <div className={styles.content_txt} dangerouslySetInnerHTML={{ __html: description }} />
      }
      </div>
    </div>
  );
};

export default BaseInfo;
